let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3sQiw")).then(() => parcelRequire('7Apec'));